export class FeatureCheckboxFilter {
    constructor(selector) {
        this.featureInput = $(selector);
        this._checkedUnitFeature = [];
    }

    filter(asset) {
        //console.log(typeof(asset.data('feature')));

        // check if all unchecked, if so don't filter by
        if (this._checkedUnitFeature.length == 0)
            return true;

        if (this._checkedUnitFeature.some(r => asset.data('feature').indexOf(r) >= 0))
        //https://stackoverflow.com/questions/16312528/check-if-an-array-contains-any-element-of-another-array-in-javascript
        {
            return true;
        }
        else {
            return false;
        }
    }

    updateValues() {
        this._checkedUnitFeature = [];

        this.featureInput.each((index, element) => {
            if ($(element).is(':checked')) {
                this._checkedUnitFeature.push($(element).val());
                //console.log($(element).val());// shows values of each feature input
            }

        });

        //console.log(this._checkedUnitFeature);// array 0,1,2,3,4
    }

    getValues() {
        return this._checkedUnitFeature;
    }
}